export const cacheKeys = {
  getNotifications: 'getNotifications',
  editNotification: 'editNotification',
  deleteNotification: 'deleteNotification',
  clearNotifications: 'clearNotifications',
};
